import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loading from "../../components/atoms/Loading";
import { BRAND_ROUTE, TOAST_CONFIG } from "../../constants";
import { removeHTTPsForSocialLinks } from "../../utils/HelperFunctions";
import { get } from "../../utils/request";
import BrandSettingsTab from "./BrandSettingsTab";
import { BrandContext } from "../../components/context/BrandContext";
import EditBrandProfilePage from "../EditBrandProfile";

function BrandSettings() {
  const { brandDetails, loading, brandId, revalidateBrandDetails } = useContext(BrandContext);
  // TODO: Refactor this code a lot of redundandatn states
  const [brandValues, setBrandValues] = useState();
  const [brandWithMagnet, setbrandWithMagnet] = useState<any>();

  async function getBrandDataFromContext() {
    try {
      const brandData = { ...brandDetails };
      if (brandData) {
        delete brandData.id;
        delete brandData.created_at;
        const formValuesWithHTTPSRemovedHttps: any = removeHTTPsForSocialLinks(brandData);
        setBrandValues(formValuesWithHTTPSRemovedHttps);
      }
    } catch (err) {
      console.log("Failed to get Brand Data", err);
      toast.error("failed to get brand data", TOAST_CONFIG);
    }
  }
  // TODO: This should be retrieved from the user primary brand.
  async function getBrandMagnets(id: string) {
    try {
      const brandDetailsFromAPI: any = await get(`${BRAND_ROUTE}${id}/?type=dashboard`);
      if (brandDetails === null) {
        alert("Failed to fetch brand details.");
      } else {
        setbrandWithMagnet(brandDetailsFromAPI);
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      // TODO: Missing Loading State.
    }
  }

  useEffect(() => {
    if (!loading && brandId) {
      getBrandDataFromContext();
      getBrandMagnets(brandId);
    }
  }, [brandDetails]);

  return brandWithMagnet && brandDetails && !loading && brandId ? (
    <>
      <BrandSettingsTab />

      {/* Form */}
      <EditBrandProfilePage
        brandId={brandId}
        revalidateBrandDetails={revalidateBrandDetails}
        brandDetails={brandValues}
      />
    </>
  ) : (
    <Loading />
  );
}

export default BrandSettings;
